import { ReportCustomFieldType } from "@shared/lib/types/reports";
import { useEffect, useState } from "react";

export type ReportFieldDefault = string | number | undefined;

type UseReportCustomFieldsFormArgs = {
  isCreateMode: boolean;
  createSession: number;
};

function resetToInitial() {
  return {
    fieldName: "",
    fieldType: ReportCustomFieldType.STRING,
    fieldDefault: undefined as ReportFieldDefault,
    description: "",
  };
}

export function useReportCustomFieldsForm({
  isCreateMode,
  createSession,
}: UseReportCustomFieldsFormArgs) {
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState<ReportCustomFieldType>(
    ReportCustomFieldType.STRING
  );
  const [fieldDefault, setFieldDefault] = useState<ReportFieldDefault>(
    undefined
  );
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!isCreateMode) return;
    const initial = resetToInitial();
    setFieldName(initial.fieldName);
    setFieldType(initial.fieldType);
    setFieldDefault(initial.fieldDefault);
    setDescription(initial.description);
  }, [isCreateMode, createSession]);

  return {
    fieldName,
    setFieldName,
    fieldType,
    setFieldType,
    fieldDefault,
    setFieldDefault,
    description,
    setDescription,
  };
}
